module.exports = __webpack_public_path__ + "img/ma.b119e23c.png";